import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { ApiService } from 'services/api.service';
import { ClientNotificationByClientIdListItemPagedResponse } from 'types/client.interface';
import { formatDatetime } from 'util/date.utility';

@Component({
  selector: 'app-client-notifications',
  standalone: true,
  imports: [NgClass, TranslateModule, NgbPagination, SpinnerComponent],
  templateUrl: './client-notifications.component.html',
  styleUrl: './client-notifications.component.scss'
})
export class ClientNotificationsComponent implements OnInit {
  public readonly formatDateTime = formatDatetime;
  @Input() clientId!: string;
  page: number = 1;
  pageSize: number = 10;
  notifications?: ClientNotificationByClientIdListItemPagedResponse;
  isLoading: boolean = true;
  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications(): void {
    this.isLoading = true;

    if (this.clientId) {
      this.apiService.getClientNotifications(this.clientId, this.page, this.pageSize).subscribe(
        (data: ClientNotificationByClientIdListItemPagedResponse) => {
          this.notifications = data;
          this.isLoading = false;
        },
        (error: any) => {
          console.error(error);
        }
      );
    }
  }

  onPageChange(): void {
    this.getNotifications();
  }

  onPageSizeChange(pageSize: Event) {
    const selectedValue = Number((pageSize.target as HTMLSelectElement).value);
    this.pageSize = selectedValue;
    this.page = 1;
    this.getNotifications();
  }

  removeLinks(text: string): string {
    return text.replace(/<a[^>]*>/g, '').replace(/<\/a>/g, '');
  }
}
